import { EmployeeInterface } from "../../../common/interfaces/EmployeeInterface";
import { JSX } from "react";
import { getFormattedDeletionDate } from "../utils/getFormattedDeletionDate";

interface Props {
    employeeMeData?: EmployeeInterface;
}

export const EmployeeInactiveNotification = (
    props: Props,
): JSX.Element | null => {
    const { employeeMeData } = props;

    if (!employeeMeData?.account_deletion_date) {
        return null;
    }

    const formattedDeletionDate = getFormattedDeletionDate(
        employeeMeData?.account_deletion_date,
    );

    return (
        <div className={"p-employee-inactive__content__notification"}>
            <p>
                Je hebt tot <span>{formattedDeletionDate}</span> de tijd om je
                certificaten te downloaden. Na deze datum worden jouw gegevens
                en certificaten automatisch definitief van ons platform
                verwijderd.
            </p>
        </div>
    );
};
